import { writable } from 'svelte/store';

export type DialogStores = ReturnType<typeof createDialogStores>;

export const createDialogStores = () => {
	const open = writable(false);

	return {
		states: { open }
	};
};
